import { render, staticRenderFns } from "./studentifno-addstudent-form.vue?vue&type=template&id=5136cb90&scoped=true"
import script from "./studentifno-addstudent-form.vue?vue&type=script&lang=js"
export * from "./studentifno-addstudent-form.vue?vue&type=script&lang=js"
import style0 from "./studentifno-addstudent-form.vue?vue&type=style&index=0&id=5136cb90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5136cb90",
  null
  
)

export default component.exports